import React from 'react';

const LineSection = () => (
  <div
    className="border-b mx-3 pt-1 border-solid border-neutral-200 opacity-50"
  />
);

export default LineSection;